import React from 'react';

import { RegionList } from '../types';

import CityList from './CityList';

interface GroupedCityListProps {
    list: RegionList;
    filter: string;
    onSelection: (id: number) => void;
    currentSelection: Set<number>;
}

const GroupedCityList = ({
    list,
    filter,
    onSelection,
    currentSelection,
}: GroupedCityListProps) => (
    <>
        {list.map((region) => (
            <CityList
                list={region.cityList}
                headline={region.name}
                key={region.id}
                filter={filter}
                onSelection={onSelection}
                currentSelection={currentSelection}
            />
        ))}
    </>
);

export default GroupedCityList;
